import styled from 'styled-components';
import { Layout } from 'antd';

export const StyledSider = styled(Layout.Sider)`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
`;
